export const RecommendationPageTitle = {
    name: "Recommendations",
    translationKey: "recommendations",
};

export const RecommendationPageSubtitle = {
    name: "Here are some popular recommendations selected for you based on your decision making stage",
    translationKey: "recommendationPageSubtitle",
};

export const RecommendationBannerText = {
    name: "Recommended for you",
    translationKey: "recommendationBannerText",
};

export const RecommendationBannerTextShort = {
    name: "For You",
    translationKey: "forYou",
};

export const RecommendationButtonText = {
    name: "Check it out",
    translationKey: "recommendationCTA",
};

export const ViewMoreText = {
    name: "View more",
    translationKey: "viewMoreText",
};

export const InboxPromptText = {
    name: "Let us help you take your next step with personalised recommendations!",
    translationKey: "inboxPromptText",
};

export const InboxPromptLinkText = {
    name: "Let's go!",
    translationKey: "inboxPromptLinkText",
};

export const RecommendationLinkTextForBlog = {
    name: "Go to blog",
    translationKey: "recommendationLinkTextForBlog",
};

export const RecommendationLinkTextForCommunity = {
    name: "Go to community",
    translationKey: "recommendationLinkTextForCommunity",
};

export const RecommendationLinkTextForEvent = {
    name: "Go to event",
    translationKey: "recommendationLinkTextForEvent",
};

export const RecommendationLinkTextForAmbassador = {
    name: "Go to ambassador",
    translationKey: "recommendationLinkTextForAmbassador",
};

export const RecommendationLinkTextForArticle = {
    name: "Go to article",
    translationKey: "recommendationLinkTextForArticle",
};

export const RecommendationLinkTextForVideo = {
    name: "Go to video",
    translationKey: "recommendationLinkTextForVideo",
};

export const RecommendationLinkTextForUniversityWebpage = {
    name: "Go to university webpage",
    translationKey: "recommendationLinkTextForUniversityWebpage",
};

export const RecommendationLinkTextForUniversityOther = {
    name: "Go to other",
    translationKey: "recommendationLinkTextForOther",
};

export const RecommendationPageGenericText = {
    name: "Here are some popular next best steps that we have selected just for you",
    translationKey: "recommendationPageGenericText",
};

export const RecommendationPagePersonalisedText = {
    name: "Here are some popular next best steps that we have selected just for you based on where you are in your decision making journey",
    translationKey: "recommendationPagePersonalisedText",
};

export const RecommendationPromptText = {
    name: "Tell us where you are in your decision-making process for personalised recommendations",
    translationKey: "recommendationPromptText",
};

export const RecommendationPromptLinkText = {
    name: "Update now",
    translationKey: "recommendationPromptLinkText",
};
